import { defineAsyncComponent } from 'vue'

/** Contacto de reserva de minotaria.es si el panel no tiene email de contacto (se usa el del panel). Ref: https://trello.com/c/2DKePjFr */
export const CORREO_MINOTARIA = 'comunicaciones@minotaria.es'

/**
 * Plantilla de minotaria.es (web agregadora). Los componentes se cargan solo cuando se usan,
 * así que las webs de notaría no los descargan.
 */
export const encargoMinotaria = {
  canal: 'minotaria',
  pasoDestino: defineAsyncComponent(() => import('../components/minotaria/MinotariaPasoNotaria.vue')),
  avisoPrivacidad: defineAsyncComponent(() => import('../components/minotaria/MinotariaPrivacidad.vue')),
  textoExitoSinDestino: 'Hemos recibido su solicitud. Le asignaremos una notaría y le contactaremos.',
  /** "Qué pasa ahora" cuando el encargo se queda sin notaría: primero se le asigna una (plazo de la decisión 2.9 de docs/minotaria.md). */
  siguienteSinDestino: { titulo: 'Le asignamos una notaría', texto: 'Le avisaremos en un máximo de 48 horas.' },
  /** Contacto que se muestra al ciudadano: sin teléfono, solo el correo del panel. Ref: https://trello.com/c/pooUEbKK */
  sinTelefono: true,
  // Zona que indicó el ciudadano en el paso "Notaría": la bandeja de minotaria.es la usa para repartir los "sin preferencia".
  // Con videoconferencia no se pide zona (puede firmar con cualquier notaría que la ofrezca)
  datosExtra: () => {
    if (useState<any>('solicitudWeb').value?.firmaVideoconferencia) return { zona: null }
    return {
      zona: {
        provincia: useState<string | null>('minotariaProvincia').value ?? null,
        localidad: (useState<string>('minotariaLocalidad').value ?? '').trim() || null,
      },
    }
  },
}

const RUTAS_MINOTARIA = [
  'index', 'encargo-online', 'mi-encargo', 'tramites', 'tramites-slug', 'notarias', 'notarias-provincia',
  'AvisoLegal', 'ProteccionDatos', 'PoliticaCookies', 'Accesibilidad',
  '404', 'error',
]
const RUTAS_BLOG = ['Blog', 'blog-id']

/** El blog se activa desde el panel (Blog → "Blog visible"), igual que el ShowBlog del menú de las notarías. */
export function blogMinotariaActivo(notaria: any): boolean {
  return !!notaria?.Theme?.Menu?.ShowBlog
}

/** Páginas de minotaria.es: el resto (notarios, equipo…) es de las webs de notaría y da 404. El blog, solo si está activo. */
export const rutasMinotaria = (notaria: any) =>
  blogMinotariaActivo(notaria) ? [...RUTAS_MINOTARIA, ...RUTAS_BLOG] : RUTAS_MINOTARIA
